<template>
  <div class="col px-0 px-lg-3 wisssh pb-4">
    <!--<div class="left">-->
    <h5
      id="user-wish-list-head"
      class="mywishlist"
						data-test="wishlistHeading"
    >
      My Wishlist
    </h5>
    <hr>
			<page-loader v-if="showLoader">
			</page-loader>
    <!--<loading-->
      <!--class="lodderz"-->
      <!--:active.sync="showLoader"-->
      <!--:can-cancel="false"-->
      <!--:is-full-page="false"-->
      <!--:opacity="1"-->
      <!--loader="dots"-->
    <!--/>-->
    <div class="userwishlist">
      <div
        class="row p-4"
        v-if="WishlistProduct.length===0 && !showLoader"
      >
        <p
          class="col-12 text-center"
          id="'user-no-order"
										data-test="wishlistNoFvrtsHeading"
        >
          Currently you have no favorites
        </p>
        <br>
      </div>
      <div
        class="cart-wrapper"
        v-for="(product,index) in WishlistProduct"
        :key="product.product_id"
        v-else
      >
        <div class="left">
          <div class="cart-items-wrapper">
            <div class="cart-item">
              <div class="cart-grid">
                <div class="cart-contents-wrapper">
                  <div class="description">
                    <router-link
                      class="cart-product-title"
                      tag="p"
                      :to="{
                                    name: 'ProductDetails',
                                    query:{
                                      productName: product.product_name,
                                      productId: product.product_id
                                     }
                                    }"
                      :id="'cart-pdt-image-'+product.product_id"
																						:data-test="'wishlistPdtName'+index"
                    >
                      {{product.product_name}}
                    </router-link>
                    <div
                      class="pricy"
                      v-if="product.vendor_product_inventories &&
                          product.vendor_product_inventories[0] &&
                          product.vendor_product_inventories[0].price"
                    >
                      <span v-if="product.vendor_product_inventories[0].promotional_prices &&
                          product.vendor_product_inventories[0].promotional_prices[0] &&
                          product.vendor_product_inventories[0].promotional_prices[0].promotion_applied_price"
																												:data-test="'wishlistPdtPromoPrice'+index"
																												:id="'wishlistPdtPromoPrice'+index">
                        {{product.vendor_product_inventories[0].promotional_prices[0].promotion_applied_price |
                      currencyConversion}}
                      </span>
                      <span v-else
																												:data-test="'wishlistPdtPrice'+index"
																												:id="'wishlistPdtPrice'+index">
                        {{product.vendor_product_inventories[0].price | currencyConversion}}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  class="cart-image-warpper"
                  v-if="product.product_details&&product.product_details.image_URL_1"
                >
                  <out-of-stock v-if="!(product.vendor_product_inventories &&
                          product.vendor_product_inventories[0]) ||
                        (product.vendor_product_inventories[0].available_stock < 1)" />
                  <img
                    class="cart-product-image"
                    :src="product.product_details.image_URL_1"
                    alt
																				:data-test="'wishlistPdtImg'+index"
																				:id="'wishlistPdtImg'+index"
                  >
                </div>
                <div class="wish-remove">
                  <button
                    type="button"
                    class="btn btn-link"
                    @click.prevent="deleteFromWish(product.product_id,index)"
                    :id="'wish-list-remove-btn-'+index"
																				:data-test="'wishlistPdtDlteBtn'+index"
                  >
                    <i class="fas fa-trash"
																							:data-test="'wishlistPdtDlteIcon'+index"
																							:id="'wishlistPdtDlteIcon'+index"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--<div-->
    <!--class="row p-4 align-items-center wishlist-item"-->
    <!--v-for="(product,index) in WishlistProduct"-->
    <!--:key="product.product_id"-->
    <!--&gt;-->
    <!--<div-->
    <!--class="col-4 col-md-2 product-image-cart"-->
    <!--v-if="product.product_details&&product.product_details.image_URL_1"-->
    <!--&gt;-->
    <!--<out-of-stock-->
    <!--v-if="!(product.vendor_product_inventories &&-->
    <!--product.vendor_product_inventories[0]) ||-->
    <!--(product.vendor_product_inventories[0].available_stock < 1)"-->
    <!--&gt;</out-of-stock>-->
    <!--<img-->
    <!--class="fluid-img"-->
    <!--style="width: 75px; height: 75px;object-fit: contain;"-->
    <!--:src="product.product_details.image_URL_1"-->
    <!--alt-->
    <!--srcset-->
    <!--:id="'wish-list-pdt-img-'+index"-->
    <!--&gt;-->
    <!--</div>-->
    <!--<div class="col-8 col-md-3">-->
    <!--<router-link-->
    <!--:to="{-->
    <!--path: '/product_description',-->
    <!--query: {-->
    <!--productName: product.product_name,-->
    <!--productId: product.product_id-->
    <!--}-->
    <!--}"-->
    <!--:id="'wish-list-pdt-name-link&#45;&#45;'+index"-->
    <!--&gt;{{product.product_name}}</router-link>-->

    <!--</div>-->
    <!--<div-->
    <!--class="col-4 p-3 col-md-3"-->
    <!--v-if="product.vendor_product_inventories &&-->
    <!--product.vendor_product_inventories[0] &&-->
    <!--product.vendor_product_inventories[0].price"-->
    <!--&gt;-->
    <!--<p :id="'wish-list-pdt-price-'+index" style="margin-bottom: 0; white-space: nowrap;">-->
    <!--{{product.vendor_product_inventories[0].price |-->
    <!--currencyConversion}}-->
    <!--</p>-->
    <!--</div>-->
    <!--<div class="col-4 p-3 col-md">-->

    <!--</div>-->
    <!--<div class="col-4 col-md">-->
    <!--<button-->
    <!--type="button"-->
    <!--class="btn btn-sm blue-btn my-3"-->
    <!--@click.prevent="deleteFromWish(product.product_id,index)"-->
    <!--:id="'wish-list-remove-btn-'+index"-->
    <!--&gt;Remove</button>-->
    <!--</div>-->
    <!--</div>-->

  </div>
</template>
<script>
// import Loading from 'vue-loading-overlay'
import { mapActions, mapGetters } from 'vuex'
import OutOfStock from '@/components/widgets/outofstock/OutOfStock'
import { store } from '@/store/store'
import { productApi } from '@/services/ApiServices/productApi'
import { customerApi } from '@/services/ApiServices/customerApi'
import PageLoader from '../../../shared/loader/pageLoader'
// import product from '@/components/widgets/Product';

export default {
	components: {
		PageLoader,
		OutOfStock
		// Loading
		// product,
	},
	data () {
		return {
			WishlistProduct: [],
			showLoader: true
		}
	},
	mounted () {
		if (store.state.user.loginStatus === false) {
			this.$router.push('/')
		}
		setTimeout(() => {
			this.getWishlistFromServer()
		}, 1000)
	},
	computed: {
		...mapGetters('wishlist', [
			'getWishlistProducts',
			'getWishlistCount',
			'getWishListIds'
		]),
		WishlistProducts () {
			return this.WishlistProduct
		}
	},
	methods: {
		...mapActions('wishlist', ['deleteFromWishlist']),
		...mapActions('wishlist', ['addToWishlist', 'deleteFromWishlist']),
		updateWishList () {
			customerApi
				.insertWishList()
		},
		deleteFromWish (product, index) {
			this.$dialog
				.confirm('Are you sure you want to remove this product?')
				.then((dialog) => {
					this.deleteFromWishlist(product)
					this.updateWishList()
					this.WishlistProduct.splice(index, 1)
					this.$forceUpdate()
					this.$toasted.show('Successfully deleted the product', {
						icon: 'exclamation-circle',
						position: 'bottom-center'
					})
				})
				.catch(() => {
					// console.log('Clicked on cancel')
				})
		},
		continueShoping () {
			this.$router.push('/')
		},
		getWishlistFromServer () {
			if (this.$route.query.product_id) {
				this.addToWishlist(this.$route.query.product_id)
				this.updateWishList()
				this.$forceUpdate()
			}

			productApi
				.getProductsByIds(this.getWishListIds)
				.then((res) => {
					if (res) {
						const products = JSON.parse(JSON.stringify(res.data))
						products.forEach((product) => {
							let vpi = product.vendor_product_inventories
							let maximumprice = 5000
							if (vpi && vpi.length > 0) {
								vpi = vpi[0]
								if (vpi && maximumprice < vpi.price) {
									maximumprice = vpi.price
								}
								product.vpi = vpi
								product.stock = vpi.available_stock
								product.max_quantity = vpi.max_quantity
								product.price = vpi.price
								product.vendor_id = vpi.vendor_id
							}
							if (vpi && vpi.promotional_prices) {
								let promo = vpi.promotional_prices
								product.promotions = promo
								if (vpi && vpi.length > 0 && promo && promo.length > 0) {
									promo = promo[0]
								}
								product.maximumprice = maximumprice
								if (promo && promo[0]) {
									product.promotion = promo[0]
									product.promotional_price = promo[0].promotion_applied_price
								}
							}
							if (
								product.product_details &&
                product.product_details.images &&
                product.product_details.images[0]
							) {
								product.image_url = product.product_details.images[0]
							}
						})
						setTimeout(() => {
							this.WishlistProduct = products
							this.showLoader = false
						}, 1000)

						this.$forceUpdate()
					}
				})
				.catch((e) => {
					this.showLoader = false
				})
		}
	}
}
</script>
